import React, { useCallback } from 'react';
import { Box, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { subscriptionAdminApi } from '../../subscriptionAdmin/api';
import { useAdminFetch } from '../hooks/useAdminFetch';

export default function UsageLogsTab() {
  const fetchLogs = useCallback(() => subscriptionAdminApi.listUsageLogs(), []);
  const { data, loading, error } = useAdminFetch(fetchLogs);
  const logs = Array.isArray(data) ? data : [];

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Box sx={{ overflowX: 'auto', bgcolor: 'white', borderRadius: 2, boxShadow: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Subscription</TableCell>
            <TableCell>Seconds</TableCell>
            <TableCell>Session</TableCell>
            <TableCell>At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log._id}>
              <TableCell>{String(log.subscriptionId || '').slice(-8)}</TableCell>
              <TableCell>{log.seconds ?? '—'}</TableCell>
              <TableCell>{log.sessionRef || '—'}</TableCell>
              <TableCell>{log.createdAt ? new Date(log.createdAt).toLocaleString() : '—'}</TableCell>
            </TableRow>
          ))}
          {!logs.length && (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 4, color: '#64748b' }}>
                No usage logs.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}
